import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type SupportedLocale, resolveLocale } from "@/i18n";

function toSupportedLocale(value: string): SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value)
    ? (value as SupportedLocale)
    : DEFAULT_LOCALE;
}

export function useLocale() {
  const route = useRoute();
  const i18n = useI18n();

  const applyFromEnvironment = (): void => {
    const queryLang = Array.isArray(route.query["lang"])
      ? route.query["lang"][0]
      : route.query["lang"];
    const resolved = resolveLocale(typeof queryLang === "string" ? queryLang : null);
    if (i18n.locale.value !== resolved) {
      i18n.locale.value = resolved;
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = resolved;
    }
  };

  const locale = computed<SupportedLocale>(() => toSupportedLocale(i18n.locale.value));

  return {
    locale,
    applyFromEnvironment,
  };
}
